/** Shared class groups for /login, /register, and related public auth pages.
 *  Visual language matches the Our Memories marketing landing (ink / stone / editorial).
 */

export const omPage =
  'om-auth-page min-h-screen bg-[#ffffff] dark:bg-[#151412] text-[#0f172a] dark:text-[#ffffff] selection:bg-[#2563eb]/20 dark:selection:bg-[#2563eb]/40 transition-colors duration-200';

export const omHeader =
  'relative z-10 border-b border-[rgba(20,18,16,0.1)] dark:border-white/10 bg-[rgba(247,246,243,0.9)] dark:bg-[rgba(21,20,18,0.9)] backdrop-blur-xl transition-colors duration-200';

export const omBrandAccent = 'text-[#0f172a] dark:text-[#ffffff]';

export const omNavLink =
  'text-sm font-medium text-[#64748b] hover:text-[#0f172a] dark:text-[#a8a399] dark:hover:text-[#ffffff] transition-colors';

export const omCtaSolid =
  'rounded-full bg-[#0f172a] px-4 py-2 text-sm font-semibold text-[#ffffff] hover:bg-[#1d4ed8] dark:bg-[#ffffff] dark:text-[#0f172a] dark:hover:bg-white transition-colors';

export const omBadge =
  'inline-flex items-center gap-2 rounded-full border border-[rgba(20,18,16,0.12)] dark:border-white/12 bg-[#ffffff] dark:bg-white/5 px-3 py-1 text-xs font-medium text-[#64748b] dark:text-[#a8a399]';

export const omHeroTitle =
  'font-[family-name:var(--om-auth-display)] text-[#0f172a] dark:text-[#ffffff]';

export const omLead = 'text-[#64748b] dark:text-[#a8a399]';

export const omMuted = 'text-[#94a3b8] dark:text-[#78746c]';

export const omCard =
  'rounded-[18px] border border-[rgba(20,18,16,0.1)] dark:border-white/10 bg-[#ffffff] dark:bg-[#1c1a18] shadow-[0_4px_24px_rgba(20,18,16,0.04)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.35)] transition-colors duration-200';

export const omFeatureCard =
  'rounded-[16px] border border-[rgba(20,18,16,0.1)] dark:border-white/10 bg-[#ffffff] dark:bg-white/[0.03] p-6 hover:border-[rgba(20,18,16,0.18)] dark:hover:border-white/20 transition-colors';

export const omInput =
  'om-auth-input w-full rounded-full border border-[rgba(20,18,16,0.14)] dark:border-white/12 bg-white dark:bg-[#121214] py-3.5 pl-12 pr-4 text-sm text-[#0f172a] dark:text-[#ffffff] placeholder:text-[#94a3b8] dark:placeholder:text-[#78746c] focus:border-[#2563eb] dark:focus:border-[#a8a399] focus:outline-none focus:ring-2 focus:ring-[rgba(31,58,52,0.18)] dark:focus:ring-white/15 transition-all';

export const omInputPlain =
  'om-auth-input w-full rounded-full border border-[rgba(20,18,16,0.14)] dark:border-white/12 bg-white dark:bg-[#121214] px-4 py-3.5 text-sm text-[#0f172a] dark:text-[#ffffff] placeholder:text-[#94a3b8] dark:placeholder:text-[#78746c] focus:border-[#2563eb] dark:focus:border-[#a8a399] focus:outline-none focus:ring-2 focus:ring-[rgba(31,58,52,0.18)] dark:focus:ring-white/15 transition-all';

export const omLabel =
  'text-[11px] font-semibold uppercase tracking-[0.12em] text-[#94a3b8] dark:text-[#78746c]';

export const omPrimaryBtn =
  'group relative w-full flex justify-center items-center gap-2 rounded-full bg-[#0f172a] px-6 py-3.5 text-sm font-semibold text-[#ffffff] shadow-none transition-all hover:bg-[#1d4ed8] focus:outline-none focus:ring-2 focus:ring-[#2563eb]/40 focus:ring-offset-2 focus:ring-offset-[#ffffff] dark:bg-[#ffffff] dark:text-[#0f172a] dark:hover:bg-white dark:focus:ring-offset-[#151412] disabled:cursor-not-allowed disabled:opacity-50';

export const omAltBtn =
  'om-auth-alt-btn group flex w-full min-h-[52px] items-center gap-3 rounded-[14px] border border-[rgba(20,18,16,0.12)] dark:border-white/12 bg-[#ffffff] dark:bg-white/[0.04] px-3.5 py-3 text-left transition-colors hover:border-[rgba(20,18,16,0.22)] hover:bg-[#f1f5f9] dark:hover:border-white/20 dark:hover:bg-white/[0.07] focus:outline-none focus:ring-2 focus:ring-[rgba(31,58,52,0.22)]';

export const omLinkAccent =
  'font-semibold text-[#2563eb] hover:text-[#0f172a] dark:text-[#e2e8f0] dark:hover:text-[#ffffff] transition-colors';

export const omDivider = 'border-t border-[rgba(20,18,16,0.1)] dark:border-white/10';

export const omHeading = 'text-[#0f172a] dark:text-[#ffffff]';

export const omCardTitle =
  'font-[family-name:var(--om-auth-display)] text-[1.45rem] font-semibold tracking-[-0.02em] text-[#0f172a] dark:text-[#ffffff]';

export const omGradientBtn =
  'inline-flex items-center gap-2 rounded-full bg-[#0f172a] px-6 py-3.5 text-sm font-semibold text-[#ffffff] hover:bg-[#1d4ed8] dark:bg-[#ffffff] dark:text-[#0f172a] dark:hover:bg-white transition-colors';

export const omOutlineBtn =
  'inline-flex items-center rounded-full border border-[rgba(20,18,16,0.16)] dark:border-white/15 bg-[#ffffff] dark:bg-white/5 px-6 py-3.5 text-sm font-semibold text-[#0f172a] dark:text-[#ffffff] hover:bg-[#f1f5f9] dark:hover:bg-white/10 transition-colors';

export const omLoadingPage =
  'om-auth-page min-h-screen bg-[#ffffff] dark:bg-[#151412] flex flex-col items-center justify-center gap-4 transition-colors duration-200';
